import * as types from "./mutation-type";

export default {
    [types.SET_SHIPPINGS](state, payload) {
        state.shippings = payload
    },
    [types.SET_LOADING_CALCULATE](state, payload) {
        state.loadingCalculate = payload
    },
    [types.SET_SHIPPING_METHOD](state, payload) {
        state.shippingMethod = payload
    },
    [types.SET_CEP_DESTIONATION](state, payload) {
        state.cepDestination = payload
    }
}
